import { queryOptions } from '@tanstack/react-query';
import { documentationListQueryFunction } from '@/modules/FileDetail/queries/documentation/list/documentationListQueryFunction.ts';

export const documentationListQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['documentation', id],
    queryFn: () => documentationListQueryFunction(id),
    select: (data) =>
      data.filter((item) => item.exists).map((item) => item.name),
  });
